// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1jDZF","description":"PatientConsentPreview_description__xFvv7"};